export const ClusterMarkerSvgBtoa = (hexColor: string) =>
  Buffer.from(
    `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="27" cy="27" r="23" fill="white" stroke="${hexColor}" stroke-width="4"/></svg>`
  ).toString('base64');
